<template>
    <div>
        <compWrapper title="基础信息" theme="primary">
            <compFormQuery
                v-if="type=='query'"
                class="margin-top-15 margin-right-15"
                :formdata="getBase"
                :value="formData"
                :labelWidth="120"
				placeholder="--"
            ></compFormQuery>
            <compFormEdit
                v-else
                class="margin-top-15 margin-right-15"
                ref="editform"
                :formdata="getBase"
                v-model="formData"
                :labelWidth="120"
            />

            <template slot="footer" >
				<vButton v-if="type!='query'" class="margin-right-10" theme="primary" @click="submit">保存</vButton>
				<vButton v-if="querytype!='query'" class="margin-right-10" @click="cancel">返回</vButton>
			</template>
        </compWrapper>
        <compWrapper title="产品明细" theme="info">
			<vForm class="margin-left-15 margin-top-15" :model="workData" v-if="type!='query'">
				<vFormItem label-width="auto" inline label="ERP SKU:">
					<vInput v-model="workData.sku" readonly suffix="search" @on-icon-click="handleSkuErp"></vInput>
				</vFormItem>
				<vFormItem label-width="auto" inline label="调整后库存">
					<vInput clearable v-model="workData.qty" />
				</vFormItem>
                <vButtonGroup class="inline margin-left-10">
					<vButton
						theme="primary"
						@click="addItem(workData)"
					>{{$t('global.common.add',{defaultValue:'添加'})}}</vButton>
					<vButton
						theme="info"
						@click="handleUploadData"
					>{{$t('global.common.import',{defaultValue:'导入'})}}</vButton>
				</vButtonGroup>
				<vButtonGroup >
					<vButton theme="warning" @click="removeItems">{{$t('global.common.delete',{defaultValue:'删除'})}}</vButton>
					<vButton theme="error" @click="clearAll">{{$tc('global.common.clear',2,{defaultValue:'清空'})}}</vButton>
				</vButtonGroup>
			</vForm>
            <vTableSimple
                style="max-height:200px;overflow:auto"
                class="margin-15"
                :columns="columns"
                :data="dataList"
                @on-check-change="handleCheckData"
            ></vTableSimple>
        </compWrapper>

		<!-- <compWrapper title="操作历史" theme="gray" v-if="type=='query'">
			<compLog :data="opLogList" :columns="getLogcolumns"></compLog>
		</compWrapper> -->
		<vLoading size="large" transfer :loading="loading"></vLoading>

        <compModal
			v-model="modalProps.show"
			v-bind="modalProps"
			@on-close="modalProps.show=false"
			@on-confirm="modalProps.show=false"
		>
			<component
				v-if="modalProps.component"
				:is="modalProps.component"
				v-bind="modalProps.props"
				@on-close="modalProps.show=false"
				v-on="modalProps.on"
			/>
		</compModal>
    </div>
</template>

<script>
import compErpsku from './erpsku'
// 先引入客户端才引入管理端
import {
	HttpQueryVirlWarehouseOne,
	HttpCreateVirlWarehouseOne,
	HttpAddProductOne,
	HttpImportExcel
} from "@/service/allotment";

import mixin from '../mixin'
import { mapState, mapGetters } from "vuex";

export default {
    mixins: [mixin],
    props:['activeid','querytype'],
    components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
		compFormEdit: () => import("@components/templates/formedit"),
		compUpload: () => import("@components/templates/upload"),
		compModal: () => import("@components/templates/modal"),
        compLog: () => import("@components/templates/log"),
		compErpsku,
	},
    data(){
        return {
			type: this.$route.params.type,
			id: this.$route.query.id,
			loading:false,
			formData:{},
			workData:{},
			required: [{
                required: true,
                message: "该信息不能为空,请填写"
			}],
			dataList:[],
			modalProps:{
				show: false,
				formdata: null,
			},
        }
    },
    created(){
		this.update()
    },
    computed:{
		...mapGetters('dictionary',['getVirtualWareList']),
        getBase(){
            return [
                {
                    label: '调整单号',
                    key: "changeOrderNo",
                    required:false,
					valueText:this.formData.sourceNo,
					show:this.type=='query'
                },
                {
                    label: '虚拟仓',
                    key: "orgWarehouseId",
                    tag:'vSelect',
                    options:this.getVirtualWareList,
					props:{
						filterable:true
					}
                },
                {
                    label: '调整原因',
                    key: "remark",
                    tag:'vTextarea',
                    required:false,
                },
            ]
        },
        columns() {
			let arr = [
				{
					type: 'selection',
					formName: 'sku',
					width: this.type === 'query' ? 0 : 60
				},
				{
					title: "ERP SKU",
					key: 'sku'
                }, 
                {
					title: "当前库存",
					key: 'currentQty'
                }, 
                {
					title: '调整后库存',
					key: 'qty'
				}
			]
			return arr
        },
        
		getLogcolumns(){
			return [
				{
					title: "操作人",
					key: 'opName'
				}, {
					title: "操作类型",
					key: 'opType'
				},{
					title: "操作原因",
					key: 'remark'
				}, {
					title: "操作时间",
					key: 'opAt'
				},
			]
		}
    },
    methods:{
		
		handleCheckData(rows, val) {
			// console.log(rows,val)
			this.checkedData = val;
		},
		//上传数据
		async handleUploadData() {
			const bool = await this.$refs.editform.validate();
			if (!bool) {
				this.$VMessage.warning(this.$t('fe.form.require'));
				return;
			}
			this.modalProps = {
				show: true,
				title: this.$t('global.common.import', { defaultValue: '导入数据' }),
				component: "compUpload",
				showFooter: false,
				width: "middle",
				props: {
					data: {
						orgWarehouseId:this.formData.orgWarehouseId || null,
					},
					name: "multipartFile",
					ajaxRequest: HttpImportExcel,
					
					download: () => {
						this.handleWebfs(process.env.VUE_APP_APIURL_FBB  + "/api/v2/inventory/changeOrder/changeOrderItemTemplate", {}, 'download');
					},
				},
				on: {
					'on-success': (row) => {
						Object.values(row.data || []).forEach((item) => {
							// this.addItem(item);
							this.dataList.push(item);
						})
						this.modalProps.show = false;
					}
				},
			}
		},
        //查询ERPSKU
		handleSkuErp() {
			this.modalProps = {
				show: true,
				title: 'SKU',
				component: "compErpsku",
				showFooter: false,
				width: 1000,
				props: {
					initFormData: {
						/* "search[EQ_lineId]": this.formData.lineId, */
						/* 'search[EQ_orgId]': global.SYSID, */
					}
				},
				on: {
					'on-data': (row) => {
						// console.log(row)
						// const { id: productId = "", sku = "",} = row;
						this.workData = { qty: this.workData.qty, sku:row.erpSku, productId:row.id};
						this.modalProps.show = false;
					}
				},
			}
		},
        async addItem(data) {
			const bool = await this.$refs.editform.validate();
			if (!bool) {
				this.$VMessage.warning(this.$t('fe.form.require'));
				return;
			}

			let { sku, qty } = data;
            console.log(qty)
            if(qty<0){
                this.$VMessage.warning('数量必须大于0');
				return;
            }
			if (!(sku && qty)) {
				this.$VMessage.warning('ERPSKU和数量必填');
				return;
			}

			// this.loading = true;
			HttpAddProductOne({
				orgWarehouseId:this.formData.orgWarehouseId,
				productId:this.workData.productId,
				qty:data.qty
			}).then(res=>{
				const { sku, qty } = res.data;
				// if (sku && qty) {
					const erpSkuData = this.dataList.find((item) => {
						return item.sku === sku
					});
					if (erpSkuData) {
						erpSkuData.qty += qty;
					} else {
						this.dataList.push(res.data)
					}
					this.workData = { qty: '', sku: '' };
				// }
				// this.dataList.push(res.data)

			},err=>{
				this.$VMessage.error(err.message)
			})

		},
		clearAll() {
			this.modalProps = {
				show: true,
				title: this.$tc('global.common.clear', 1, { defaultValue: '清空所有' }),
				alert: 'error',
				ajaxRequest: async () => {
					this.dataList = [];
					return { message: this.$t('global.common.haveto_empty', { defaultValue: '已清空' }) };
				}
			}
		},
		removeItems() {
			const checkedData = this.checkedData || [];
			if (!checkedData.length) {
				this.$VMessage.warning(this.$t('global.common.choose', { defaultValue: '请选择产品' }));
				return
			}
			this.modalProps = {
				show: true,
				title: this.$t('global.common.delete', { defaultValue: '删除' }),
				alert: 'warning',
				ajaxRequest: async () => {
					this.dataList = this.dataList.filter((row) => {
						return checkedData.indexOf(row.sku) == -1
					})
					return { message: this.$t('global.common.have_deleted', { defaultValue: '已删除' }) };
				}
			}

		},
		update(){
			if(this.querytype){
                this.id = this.activeid
				this.type = this.querytype
				this.difference = this.differencetype
            }else{
                this.id = this.$route.query.id
				this.type = this.type
				this.difference = this.difference
			}
			if(this.type == 'add') return
			this.loading = true;
			
			// 请求订单详情
			HttpQueryVirlWarehouseOne({
				id:this.id
			}).then(res=>{
				this.formData = res.data
				this.dataList = res.data.inventoryChangeItemRequests
				this.loading = false;
			},err=>{
				this.loading = false;
				this.$VMessage.error(err.message)
			})
		},
		addExcel(){
			this.modalProps = {
				show: true,
				title: '上传附件',
				width: 520,
				showFooter: false,
				component: "compImport",
				props:{
					erpskutitle: "ShippingLabel、PackingList、BOL三种类型支持格式为：PNG、JPG、PDF；Other格式不限",
					comptitle: '附件类型',
					actionurl: "/api/v2/ServiceWorkOrderPlan/uploadAttach",
					detailid:this.id,
				},
				on:{
					'on-success':(res)=>{
						this.workdataList.push(res.data)
					}
				}
			}
		},
		async submit(){

			const valid = await this.$refs.editform.validate()
            if (!valid) return;

			HttpCreateVirlWarehouseOne({
				orgWarehouseId:this.formData.orgWarehouseId,
				remark:this.formData.remark,
				inventoryChangeItemRequests:this.dataList
			}).then(res=>{
				this.$VMessage.success(res.message)
				this.cancel()
			},err=>{
				this.$VMessage.error(err.message)
			})
		},
		
		

		cancel(){
			this.$router.push({
				name: 'allotvirtualwarehouse',
			});
		},
		close(){
			this.$router.push({
				name: 'allotvirtualwarehouse',
			});
			this.$emit('on-close')
		},
    },

}

</script>
